import { Component, Input } from '@angular/core';
import { TableComponent } from '../../../../core/table/table.component';
import { ColumnComponent } from '../../../../core/table/column.component';

@Component({
  selector: 'app-coverage-limit',
  imports: [TableComponent, ColumnComponent],
  template: `<app-table
    [dataSource]="dataSource"
    [pageSize]="5"
    [scrollable]="false"
    [stripedRows]="false"
    theme="Dark"
    recordLabel="Limit"
    [globalFilterFields]="[
      'appliesTo',
      'limit',
      'type',
      'limitDescription',
      'comment',
    ]"
  >
    <app-column name="appliesTo" label="Applies To" width="25%" />
    <app-column name="limit" label="Limit Amount" width="25%" format="c" />
    <app-column name="type" label="Type" width="25%" />
    <app-column name="limitDescription" label="Limit Description" width="25%" />
    <app-column
      name="comment"
      label="Comment"
      [fullRow]="true"
      [fullRowLabel]="true"
    >
      <ng-template #item let-row>
        <span class="tw-text-wrap tw-leading-6">{{ row.comment }}</span>
      </ng-template>
    </app-column>
  </app-table>`,
  styles: [],
})
export class CoverageLimitComponent {
  @Input() dataSource: any;
}
